import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatTabsModule,
  MatToolbarModule,
} from '@angular/material';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import { SortablejsModule  } from 'ngx-sortablejs';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons/dist';
import { QRCodeModule } from 'angularx-qrcode';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { DndModule } from 'ng2-dnd';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxBarcodeModule } from 'ngx-barcode';
import { BsDatepickerModule, CollapseModule, ModalModule } from 'ngx-bootstrap';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { ClickStopPropagationDirective } from '../_directives';
import { DateTimePipe } from '../_pipes/date-time.pipe';
import { SaveHtmlPipe } from '../_pipes/save-html.pipe';
import { TimeWithAddPipe } from '../_pipes/time-with-add.pipe';
import { TimePipe } from '../_pipes/time.pipe';
import { DeleteComponent } from '../pages/settings/academic-year-management/modal/delete/delete.component';

@NgModule({
  imports: [
    BsDatepickerModule.forRoot(),
    SortablejsModule,
    CommonModule,
    FormsModule,
    TranslateModule.forChild(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    NgbModule.forRoot(),
    DndModule.forRoot(),
    FileUploadModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    EditorModule,
    NgxBarcodeModule,
    QRCodeModule,
    MatButtonModule,
    Angular2PromiseButtonModule.forRoot({
      // your custom config goes here
      spinnerTpl: '<span class="loadericon" ><img src="/assets/Icons/Loader.gif"  class="w-50P h-30P"/></span>',
      // disable buttons when promise is pending
      disableBtn: true,
      // the class used to indicate a pending promise
      btnLoadingClass: 'showLoading',
      // only disable and show is-loading class for clicked button,
      // even when they share the same promise
      handleCurrentBtnOnly: false
    })
  ],
  declarations: [DeleteComponent, TimePipe, TimeWithAddPipe, DateTimePipe, SaveHtmlPipe, ClickStopPropagationDirective],
  exports: [
    BsDatepickerModule,
    NgxDaterangepickerMd,
    SortablejsModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatToolbarModule,
    MatAutocompleteModule,
    PickerModule,
    ModalModule,
    CollapseModule,
    PerfectScrollbarModule,
    ColorPickerModule,
    DndModule,
    FileUploadModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    EditorModule,
    NgxBarcodeModule,
    QRCodeModule,
    Angular2PromiseButtonModule,
    DeleteComponent,
    TimePipe,
    TimeWithAddPipe,
    DateTimePipe,
    SaveHtmlPipe,
    ClickStopPropagationDirective
  ],
  entryComponents: [DeleteComponent],
  providers: [TranslateModule]
})
export class SharedModule {}
